var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */
import React from 'react';
import { IMaskInput } from 'react-imask';
export var MascaraTelefone = React.forwardRef(function TextMaskCustom(props, ref) {
    var onChange = props.onChange, other = __rest(props, ["onChange"]);
    return (_jsx(IMaskInput, __assign({}, other, { mask: '(00) 0000-0000', definitions: {
            '#': /[1-8]/,
        }, inputRef: ref, onAccept: function (value) { return onChange({ target: { name: props.name, value: value } }); }, overwrite: true })));
});
export var MascaraCelular = React.forwardRef(function TextMaskCustom(props, ref) {
    var onChange = props.onChange, other = __rest(props, ["onChange"]);
    return (_jsx(IMaskInput, __assign({}, other, { mask: '(00) 00000-0000', definitions: {
            '#': /[1-9]/,
        }, inputRef: ref, onAccept: function (value) { return onChange({ target: { name: props.name, value: value } }); }, overwrite: true })));
});
